export const licenseStatusTranslation = {
  fi: {
    LicenseStatus: {
      PENDING: 'Odottaa maksua',
      EXPIRED: 'Erääntynyt',
      EXPIRE_SOON: 'Erääntyy pian',
      PAID: 'Maksettu',
      NO_ACTIVE: 'Lisenssi erääntynyt',
      ACTIVE: 'Lisenssi aktiivinen',
      ACTIVE_DAYS: 'Erääntyy: {{count}} pv',
    },
  },
};
